module.exports = __webpack_public_path__ + "img/driving-license-illustration.4c204adf.png";